import { Config } from './Config';
import i18n from 'i18next';
import { getLanguageCode } from '../hooks/useLanguageCode';

const CORS_PROXY = "https://cors.io/?url="

async function performRequest(method, payload) {
  const headers = {
    'Content-Type': 'application/json',
    'X-API-Method': method,
    'X-UI-Language': getLanguageCode(i18n.languages),
  };

  const response = await fetch(CORS_PROXY + Config.apiURL, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return JSON.parse(data.body);
}

export function getPublicStatusPage(domain) {
  return performRequest('GetPublicStatusPage', {
    domain
  });
}
